import style from "./badges.module.scss"
import {hideBadge, setActiveBadge} from "../../action/page";
import {connect} from "react-redux";
import {useRef} from "react";
import {useOutsideAlerter} from "../../util/util";

function Badge({styleClass, page, setActiveBadge, hideBadge}) {
    const badgesRow = useRef(null);
    useOutsideAlerter(badgesRow, hideBadge);


    return (
        <div className={style.container}>
            <div className={style.info}>
                <div className={style.infoBase}>
                    <div className={style.icon}>
                        ?
                    </div>
                    <div className={style.name}>AQI Scale</div>
                </div>
                <div className={style.description}>
                    Air quality index (AQI) is used by government agencies to communicate to the public how polluted the
                    air currently is or how polluted it is forecast to become.
                </div>
            </div>
            <div className={[style.bageRow, styleClass].join(" ")}>

                {page.badges.map((item, index) => (

                    <div
                        className={[style.bageItem, style[item.class], item.active ? style.open : ""].join(" ")}
                        key={`badge${index}`}
                    >
                        <div className={style.header} onClick={() => setActiveBadge(item.color)}>
                            <div className={style.name}>{item.title}</div>
                            <div className={[style.icon, item.active ? style.hide : ""].join(" ")}>
                                <img src={item.icon} alt={item.title}/>
                            </div>
                        </div>
                        <div
                            className={[style.description, item.active ? style.active : ""].join(" ")}
                        >
                            {item.active && (
                                <div
                                    className={style.badgeRef}
                                    ref={badgesRow}
                                ></div>
                            )}

                            <div className={style.icon}>
                                <img src={item.iconContent} alt=""/>
                            </div>
                            <div className={style.text}>{item.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
}

const mapStateToProps = state => ({
    page: state.page
});

const mapDispatchToProps = dispatch => ({
    setActiveBadge: data => dispatch(setActiveBadge(data)),
    hideBadge: data => dispatch(hideBadge(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Badge);
